"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalIntervals = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/restrict-template-expressions */
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var UserInactivityModal_1 = require("@app/features/auth/components/UserInactivityModal");
var actions_1 = require("@app/features/auth/state/actions");
var NewPackagesMonitor_1 = __importDefault(require("@app/features/new-packages/components/NewPackagesMonitor"));
var config_1 = require("@app/shared/config");
var constants_1 = require("@app/shared/constants");
var utils_1 = require("@app/shared/utils");
var matomo_1 = require("@app/shared/matomo");
var log_1 = __importDefault(require("@app/shared/log"));
var initialState = {
    blastActivityStatus: false,
    secondsRemaining: config_1.Config.SESSION_TIME_COUNTDOWN,
    userInactivityVisible: false,
    isMaxLimit: false,
    isFirstTick: true
};
var GlobalIntervals = /** @class */ (function (_super) {
    __extends(GlobalIntervals, _super);
    function GlobalIntervals(props) {
        var _this = _super.call(this, props) || this;
        _this.setJwtExpiration = function () {
            var loginDate;
            if (localStorage && ('function' === typeof localStorage.getItem)) {
                var login = localStorage.getItem(constants_1.BLAST_LOGIN);
                loginDate = (login) ? new Date(login) : undefined;
            }
            var jwtExpire;
            if (sessionStorage && ('function' === typeof sessionStorage.getItem)) {
                var jwt = sessionStorage.getItem(constants_1.JWT_STORAGE_KEY);
                if (jwt) {
                    var decodedJwt = utils_1.decodeJwt(jwt);
                    // JWT expiration (converted to milliseconds)
                    jwtExpire = new Date((decodedJwt.exp * 1000) - 1E3);
                    return {
                        expirationDate: jwtExpire,
                        loginDate: (loginDate) ? loginDate : undefined,
                        maxLength: decodedJwt.max_length,
                        validityInSeconds: decodedJwt.validityInSeconds
                    };
                }
            }
            return undefined;
        };
        /**
         * Global activity interval
         * Checks whether the user is still active
         * Triggers a notification if t,he user has been inactive for too long
         */
        _this.activityTick = function () {
            if (_this.props.blastActivityTimestamp && _this.state.jwtSessionExpiration) {
                var secondsRemaining = Math.floor((_this.state.jwtSessionExpiration.expirationDate.getTime() - Date.now()) / 1000);
                _this.setState({ secondsRemaining: secondsRemaining });
                // Determine if there has been activity or if the user has not reach the max session time
                var maxLimitTime = _this.state.jwtSessionExpiration.loginDate.getTime() + (_this.state.jwtSessionExpiration.maxLength * 1000);
                // The activity window is the user's session minus the offset
                var activityWindow = _this.state.jwtSessionExpiration.expirationDate.getTime() - ((_this.state.jwtSessionExpiration.validityInSeconds * 1000) - (config_1.Config.ACTIVITY_OFFSET * 1000));
                var hasRecentActivity = moment_1.default(_this.props.blastActivityTimestamp).isSameOrAfter(activityWindow);
                var isMaxLimit = moment_1.default().isSameOrAfter(maxLimitTime);
                if (secondsRemaining <= config_1.Config.SESSION_TIME_COUNTDOWN || isMaxLimit) {
                    if (hasRecentActivity && !isMaxLimit) {
                        _this.props.onRefreshActivity(_this.props.blastActivityTimestamp);
                        _this.resetTicker();
                        _this.setState({ userInactivityVisible: false });
                    }
                    else {
                        _this.setState({
                            userInactivityVisible: true,
                            secondsRemaining: isMaxLimit || secondsRemaining <= 0 ? 0 : secondsRemaining,
                            isMaxLimit: isMaxLimit
                        });
                        if (!isMaxLimit && secondsRemaining === config_1.Config.SESSION_TIME_COUNTDOWN) {
                            _this.matomo.trackEvent('Session', 'Session Expiration Countdown displayed');
                        }
                        if (isMaxLimit || secondsRemaining <= 0) {
                            clearInterval(_this.ticker);
                            _this.setState({ blastActivityStatus: false });
                            if (isMaxLimit) {
                                _this.matomo.trackEvent('Session', 'Max Session Timeout displayed');
                            }
                        }
                    }
                }
                var env = process.env.NODE_ENV;
                if (localStorage && ('function' === typeof localStorage.getItem)) {
                    env = localStorage.getItem(constants_1.BLAST_ENV) || env;
                }
                if (env !== 'pd' && env !== 'production') {
                    if (secondsRemaining % 60 === 0 || _this.state.isFirstTick) {
                        log_1.default.info(String.fromCharCode(9829) + " " + ((_this.state.isFirstTick ? _this.state.jwtSessionExpiration.validityInSeconds : secondsRemaining) / 60) +
                            " periods remain before auto-signout due to session expiration." +
                            (" Recent activity happened on " + _this.props.blastActivityTimestamp) +
                            (". Last login at " + _this.state.jwtSessionExpiration.loginDate + ".") +
                            (" JWT expires at " + _this.state.jwtSessionExpiration.expirationDate + ".") +
                            (" You will reach the max limit at " + new Date(maxLimitTime)));
                        _this.setState({ isFirstTick: false });
                    }
                }
            }
        };
        _this.resetTicker = function () {
            clearInterval(_this.ticker);
            _this.ticker = setInterval(_this.activityTick, 1000);
            _this.setState({ isFirstTick: true });
        };
        _this.handleAcceptUserInactivity = function () {
            _this.setState({ secondsRemaining: config_1.Config.SESSION_TIME_COUNTDOWN, userInactivityVisible: false });
            _this.props.onRefreshActivity(_this.props.blastActivityTimestamp);
            _this.resetTicker();
        };
        _this.handleDeclineUserInactivity = function () {
            clearInterval(_this.ticker);
            _this.setState(initialState);
            _this.props.onLogout(true);
        };
        var loggedIn = false;
        if (localStorage && ('function' === typeof localStorage.getItem)) {
            loggedIn = !!localStorage.getItem(constants_1.BLAST_LOGIN);
        }
        if (loggedIn) {
            _this.state = __assign(__assign({}, initialState), { blastActivityStatus: true, jwtSessionExpiration: _this.setJwtExpiration() });
        }
        else {
            _this.state = initialState;
        }
        if (_this.state.blastActivityStatus && _this.state.jwtSessionExpiration) {
            _this.ticker = setInterval(_this.activityTick, 1000);
        }
        _this.matomo = new matomo_1.MatomoTracker();
        return _this;
    }
    GlobalIntervals.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.blastActivityTimestamp !== prevProps.blastActivityTimestamp) {
            if (this.props.blastActivityTimestamp && !prevProps.blastActivityTimestamp) {
                // Timestamp previously was undefined
                this.ticker = setInterval(this.activityTick, 1000);
                this.setState({ blastActivityStatus: true, jwtSessionExpiration: this.setJwtExpiration() });
            }
            else if (!this.props.blastActivityTimestamp && prevProps.blastActivityTimestamp) {
                // Timestamp has been updated to undefined
                clearInterval(this.ticker);
                this.setState({ blastActivityStatus: false, jwtSessionExpiration: undefined });
            }
            else {
                // Timestamp has been updated
                this.setState({ blastActivityStatus: true, jwtSessionExpiration: this.setJwtExpiration() });
            }
        }
    };
    GlobalIntervals.prototype.componentWillUnmount = function () {
        clearInterval(this.ticker);
    };
    GlobalIntervals.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.state.userInactivityVisible &&
                react_1.default.createElement(UserInactivityModal_1.UserInactivityModal, { onClose: function () {
                        log_1.default.debug('Closing the user inactivity modal has been disabled.');
                    }, closeOnEscape: false, onAccept: this.handleAcceptUserInactivity, onDecline: this.handleDeclineUserInactivity, secondsRemaining: this.state.secondsRemaining, isMaxLimit: this.state.isMaxLimit, hasActiveTransfers: this.props.numActiveTransfers > 0 }),
            react_1.default.createElement(NewPackagesMonitor_1.default, { isActive: this.state.blastActivityStatus })));
    };
    return GlobalIntervals;
}(react_1.Component));
exports.GlobalIntervals = GlobalIntervals;
var mapStateToProps = function (store) {
    return {
        blastActivityTimestamp: store.auth.blastActivityTimestamp,
        numActiveTransfers: store.transfers.activeTransfers.length
    };
};
var mapDispatchToProps = {
    onLogout: actions_1.logout,
    onRefreshActivity: actions_1.reconfirmAuth
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GlobalIntervals);
